import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MAX_SHORT_TEXT_LENGTH } from '../../../constants';
import { useEntityFormContext } from '../../../hooks';
import { VendorBuyingAgreementEntity } from '../../../models';
import { ControlledInput } from '../../Form';
import { VendorBuyingAgreementStatusDisplay } from './VendorBuyingAgreementStatusDisplay';

export const VendorBuyingAgreementHeader = () => {
  const { t } = useTranslation();
  const { control, readOnly, variant, watch } = useEntityFormContext<VendorBuyingAgreementEntity>();
  const watchStatus = watch('status');

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ControlledInput
          maxLength={MAX_SHORT_TEXT_LENGTH}
          label={t('vendor:buyingAgreements.form.name')}
          name="name"
          variant="standard"
          control={control}
          hideLabel={readOnly}
          required
        />
      </Grid>
      {variant !== 'drawer' && (
        <Grid item xs={12}>
          <VendorBuyingAgreementStatusDisplay status={watchStatus} />
        </Grid>
      )}
    </Grid>
  );
};
